module.exports = __webpack_public_path__ + "img/amor-base.94c90d84.png";